/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Voices_SubtitleInputs */

const en_common_voices_subtitle = /** @type {(inputs: Common_Voices_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select your preferred voice`)
};

const es_common_voices_subtitle = /** @type {(inputs: Common_Voices_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona tu voz preferida`)
};

/**
* | output |
* | --- |
* | "Select your preferred voice" |
*
* @param {Common_Voices_SubtitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_voices_subtitle = /** @type {((inputs?: Common_Voices_SubtitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Voices_SubtitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_voices_subtitle(inputs)
	return en_common_voices_subtitle(inputs)
});